import ShCard from '@/components/Helpers/ShCard';
import ShDividerLine from '@/components/Helpers/ShDividerLine';
import ShSideBarModal from '@/components/Helpers/ShSideBarModal';
import AddNewElementButton from '@/components/Common/AddNewElementButton';
import PermissionProfilesProfile from './PermissionProfilesProfile';
import PermissionProfilesCategory from './PermissionProfilesCategory';
import PermissionProfilesCreateForm from './PermissionProfilesCreateForm';
import PermissionProfilesEditForm from './PermissionProfilesEditForm';

// @vue/component
export default {
  name: 'PermissionProfiles',

  components: {
    ShCard,
    ShDividerLine,
    ShSideBarModal,
    AddNewElementButton,
    PermissionProfilesProfile,
    PermissionProfilesCategory,
    PermissionProfilesEditForm,
    PermissionProfilesCreateForm,
  },

  data() {
    return {
      isAddProfileModalVisible: false,
      isEditProfileModalVisible: false,
      currentProfile: null,
      currentProfileKey: 0,
    };
  },

  computed: {
    isLoading() {
      return this.$store.getters['app/pendingStoreActions'].includes([
        'userProfiles/getList',
        'userProfiles/update',
        'permissions/getList',
        'permissionsCategories/getList',
      ]);
    },
    userProfileList() {
      return this.$store.getters['userProfiles/list'];
    },
    getCurrentProfile() {
      return this.currentProfile;
    },
    getPermissionsList() {
      return this.$store.getters['permissions/list'];
    },
    getPermissionsCategoriesList() {
      return this.$store.getters['permissionsCategories/list'];
    },
  },

  created() {
    this.$store.dispatch('userProfiles/getList').then(() => {
      this.setCurrentProfile(this.userProfileList[0]);
    });
    this.$store.dispatch('permissions/getList');
    this.$store.dispatch('permissionsCategories/getList');
  },

  methods: {
    getPermissionsByCategory(categoryId) {
      return this.getPermissionsList.filter(permission => permission.category_id === categoryId);
    },
    setCurrentProfile(profile) {
      this.currentProfileKey += 1;
      let currentProfile = {
        id: profile.id,
        name: profile.name,
        type: profile.type,
        description: profile.description,
        permissions: profile.permissions ? profile.permissions.split(',') : [],
      };
      this.currentProfile = currentProfile;
    },
    async updateProfilePermission(permissionSlug) {
      let { permissions } = this.currentProfile;
      if (permissions.includes(permissionSlug)) permissions = permissions.filter(value => value !== permissionSlug);
      else permissions.push(permissionSlug);
      this.currentProfile.permissions = permissions;
      permissions = permissions.join(',');
      await this.$store.dispatch('userProfiles/updatePermission', {
        id: this.currentProfile.id,
        permissions,
      });
      this.$notify.success({
        title: 'Edycja uprawnień',
        message: 'Dane zapisane poprawnie',
        customClass: 'callmeweb-notification',
      });
      this.$store.dispatch('userProfiles/getList');
    },
  },
};
